import { createAction } from 'redux-actions';

export const MODAL_CONFIRM_YES = 'MODAL_CONFIRM_YES';

export default createAction(MODAL_CONFIRM_YES);
